<script setup lang="ts">
import type { BaseNotificationDialogProps } from '@nimbus/types'
import { useAttrs } from 'vue'
import { useDefaults } from '#imports'

defineOptions({
    inheritAttrs: false
})

/** How the accept button is painted: the orange CTA, or a soft secondary button. */
export type NotificationAcceptVariant = 'cta' | 'secondary'

export interface NotificationMessageButtonProps {
    actionType: 'accept' | 'dismiss'
    action: BaseNotificationDialogProps['notification']['acceptAction'] | BaseNotificationDialogProps['notification']['dismissAction']
    pending: boolean
    /**
     * Ignored by the dismiss button, which is always outlined secondary.
     *
     * @default
     * 'cta'
     */
    acceptVariant?: NotificationAcceptVariant
}
const _props = defineProps<NotificationMessageButtonProps>()
const props = useDefaults({
    props: _props,
    defaults: {
        acceptVariant: 'cta'
    }
})
const attrs = useAttrs()

const emit = defineEmits<{
    click: []
}>()
</script>

<template>
    <div class="notifcation-dialog-message-button">
        <template v-if="props.actionType === 'accept'">
            <UIButton
                v-if="props.action"
                :as="props.acceptVariant === 'secondary' ? 'default' : 'cta'"
                :color="props.acceptVariant === 'secondary' ? 'secondary' : undefined"
                :outlined="props.acceptVariant === 'secondary'"
                block
                size="xl"
                v-bind="attrs"
                :loading="props.pending"
                @click="emit('click')"
            >
                {{ props.action.text }}
                <template v-if="props.acceptVariant !== 'secondary'" #append>
                    <UIIcon name="arrow-right" size="9px" />
                </template>
            </UIButton>
        </template>
        <template v-if="props.actionType==='dismiss'">
            <UIButton
                v-if="props.action"
                color="secondary"
                outlined
                block
                size="xl"
                v-bind="attrs"
                :loading="props.pending"
                @click="emit('click')"
            >
                {{ props.action.text }}
            </UIButton>
        </template>
    </div>
</template>
